//==========================================================================
// product-detail.js
//==========================================================================

function initFaqHeight() {
  if ($(window).width() <= 767) return;

  $(".faq-row").each(function () {
    const $row = $(this);
    const $items = $row.find(".faq-item");

    function syncHeight() {
      if ($(window).width() <= 767) {
        $items.css({
          "flex-basis": "",
          height: "",
        });
        return;
      }

      $items.css({
        "flex-basis": "auto",
        height: "",
      });

      const openItems = $items.filter("[open]");

      if (openItems.length === 2 || openItems.length === 0) {
        setTimeout(() => {
          const heights = $items
            .map(function () {
              return $(this).outerHeight();
            })
            .get();
          const maxHeight = Math.max(...heights);

          $items.css({
            "flex-basis": maxHeight,
            height: maxHeight,
          });
        }, 0);
      } else {
        $items.css({
          "flex-basis": "auto",
          height: "",
        });
      }
    }

    $items.on("toggle", function () {
      syncHeight();
    });

    syncHeight();
  });
}

function initVoiceSlider() {
  const slickOptions = {
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    dots: true,
    arrows: false,
    infinite: false
  };

  function checkSlider() {
    $('.js-voice_slider').each(function () {
      const $slider = $(this);

      if ($(window).width() <= 767) {
        if (!$slider.hasClass('slick-initialized')) {
          $slider.slick(slickOptions);
          // Re-init comment toggle after slider clones elements
          setTimeout(function() {
            if (typeof initCommentToggle === 'function') {
              initCommentToggle();
            }
          }, 100);
        }
      } else {
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('unslick');
          // Re-init comment toggle after unslick
          setTimeout(function() {
            if (typeof initCommentToggle === 'function') {
              initCommentToggle();
            }
          }, 100);
        }
      }
    });
  }

  checkSlider();
  $(window).on('resize orientationchange', checkSlider);
}

function initGallerySlider() {
  if ($(".p-product-detail__gallery").length) {
    const mainSliderOptions = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: ".p-product-detail__gallery__thumb",
    };

    const thumbSliderOptions = {
      slidesToShow: 9,
      slidesToScroll: 1,
      asNavFor: ".p-product-detail__gallery__main",
      dots: false,
      arrows: false,
      focusOnSelect: true,
      infinite: true,
      variableWidth: true,
      draggable: true,
      swipeToSlide: true,
      touchThreshold: 10,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 9,
            variableWidth: true,
            draggable: true,
            swipeToSlide: true,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 9,
            variableWidth: true,
            draggable: true,
            swipeToSlide: true,
          }
        }
      ]
    };

    function initializeGallerySliders() {
      const $mainGallery = $(".p-product-detail__gallery__main");
      const $thumbGallery = $(".p-product-detail__gallery__thumb");

      $mainGallery.slick(mainSliderOptions);
      $thumbGallery.slick(thumbSliderOptions);

      setTimeout(function () {
        $mainGallery.slick('setPosition');
        $thumbGallery.slick('setPosition');
      }, 0);
    }

    function refreshSliders() {
      const $mainGallery = $(".p-product-detail__gallery__main");
      const $thumbGallery = $(".p-product-detail__gallery__thumb");

      if ($mainGallery.hasClass('slick-initialized')) {
        $mainGallery.slick('setPosition');
      }
      if ($thumbGallery.hasClass('slick-initialized')) {
        $thumbGallery.slick('setPosition');
      }
    }

    initializeGallerySliders();

    let resizeTimer;
    $(window).on('resize orientationchange', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        refreshSliders();
      }, 250);
    });

    $(window).on('load', function () {
      refreshSliders();
    });
  }
}

$(function () {
  initVoiceSlider();
  initGallerySlider();
  initFaqHeight();

  let resizeTimer;
  $(window).on("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if ($(window).width() <= 767) {
        $(".faq-item").css({
          "flex-basis": "",
          height: "",
        });
        return;
      }

      $(".faq-row").each(function () {
        const $items = $(this).find(".faq-item");
        const openItems = $items.filter("[open]");

        $items.css({
          "flex-basis": "auto",
          height: "",
        });

        if (openItems.length === 2 || openItems.length === 0) {
          setTimeout(() => {
            const heights = $items
              .map(function () {
                return $(this).outerHeight();
              })
              .get();
            const maxHeight = Math.max(...heights);

            $items.css({
              "flex-basis": maxHeight,
              height: maxHeight,
            });
          }, 0);
        }
      });
    }, 250);
  });
});

// Handle sticky nav inside container (improved)
function initStickyNav(navSelector) {
  const $nav = $(navSelector);
  const $container = $(".p-product-detail__top");
  const $content = $(".p-product-detail__gallery");
  const $win = $(window);

  // state
  let navTop = 0,
    navLeft = 0,
    navWidth = 0,
    navHeight = 0;
  let containerTop = 0,
    containerBottom = 0,
    containerPadding = 0;
  let navState = "static"; // "static" | "fixed" | "absolute"
  let ticking = false;
  const headerHeight = 130; // adjust if you have a fixed header

  function getContainerPadding() {
    const styles = getComputedStyle($container[0]);
    return parseInt(styles.paddingBottom || 0, 10) || 0;
  }

  function addPlaceholder() {
    $nav.next(".nav-placeholder").remove();
    $nav.after(
      `<div class="nav-placeholder" style="width:${navWidth}px; height:${navHeight}px"></div>`
    );
  }

  function removePlaceholder() {
    $nav.next(".nav-placeholder").remove();
  }

  // recalc positions/sizes — if there's a placeholder, use it
  function recalc() {
    containerTop = $container.offset().top;
    containerBottom = containerTop + $container.outerHeight();
    containerPadding = getContainerPadding();

    const $ph = $nav.next(".nav-placeholder");
    if ($ph.length) {
      navTop = $ph.offset().top;
      navLeft = Math.round($ph.offset().left);
      navWidth = Math.round($ph.outerWidth());
      navHeight = Math.round($ph.outerHeight());
    } else {
      navTop = $nav.offset().top;
      navLeft = Math.round($nav.offset().left);
      navWidth = Math.round($nav.outerWidth());
      navHeight = Math.round($nav.outerHeight());
    }
  }

  function setFixed() {
    $nav.removeClass("is-absolute").addClass("is-fixed").css({
      position: "fixed",
      top: headerHeight + "px",
      left: navLeft + "px",
      width: navWidth + "px",
      "z-index": 1000,
    });
    addPlaceholder();
    navState = "fixed";
  }

  function setAbsolute() {
    $nav.removeClass("is-fixed").addClass("is-absolute").css({
      position: "absolute",
      top: containerBottom - containerTop - navHeight - containerPadding + "px",
      left: "",
      width: navWidth + "px",
      zIndex: 1000,
    });
    addPlaceholder();
    navState = "absolute";
  }

  function resetSticky() {
    $nav.removeClass("is-fixed is-absolute").css({
      position: "",
      top: "",
      left: "",
      width: "",
      "z-index": "",
    });
    removePlaceholder();
    navState = "static";
  }

  function onScroll() {
    if (!isDesktop()) return;

    recalc();

    if (Math.round($content.height()) < navHeight) {
      if (navState !== "static") resetSticky();
      return;
    }

    const st = $win.scrollTop();

    if (st >= navTop - headerHeight) {
      const navBottom = st + headerHeight + navHeight;

      if (navBottom < containerBottom - containerPadding) {
        if (navState !== "fixed") {
          recalc();
          setFixed();
        } else {
          $nav.css({ left: navLeft + "px", width: navWidth + "px" });
          addPlaceholder();
        }
      } else {
        if (navState !== "absolute") {
          recalc();
          setAbsolute();
        } else {
          $nav.css({
            top: containerBottom - containerTop - navHeight - containerPadding + "px",
            width: navWidth + "px",
          });
          addPlaceholder();
        }
      }
    } else {
      if (navState !== "static") resetSticky();
    }
  }

  function onResize() {
    if (!isDesktop()) {
      resetSticky();
      return;
    }

    recalc();

    if (navState === "fixed") {
      $nav.css({ left: navLeft + "px", width: navWidth + "px" });
      addPlaceholder();
    } else if (navState === "absolute") {
      $nav.css({
        top: containerBottom - containerTop - navHeight - containerPadding + "px",
        width: navWidth + "px",
      });
      addPlaceholder();
    } else {
      removePlaceholder();
    }

    onScroll();
  }

  // optimized event binding
  $win.on("scroll", function () {
    if (!ticking) {
      requestAnimationFrame(function () {
        onScroll();
        ticking = false;
      });
      ticking = true;
    }
  });

  $win.on("resize orientationchange", function () {
    if (!ticking) {
      requestAnimationFrame(function () {
        onResize();
        ticking = false;
      });
      ticking = true;
    }
  });

  // init
  recalc();
  onScroll();
}

// helper
function isDesktop() {
  return window.matchMedia("(min-width: 1025px)").matches;
}
function isMobile() {
  return window.matchMedia("(max-width: 1024px)").matches;
}

// init
$(function () {
  setTimeout(function () {
    initStickyNav(".js-product-sticky");
  }, 100);
});
